import React, { useEffect, useState } from "react";
import "./App.css";
import { I18nProvider, useI18n } from "./i18n";
import { BookingProvider, useBooking } from "./lib/booking-context";
import { CurrencyProvider } from "./lib/currency-context";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Benefits } from "./components/Benefits";
import { Services } from "./components/Services";
import { Calculator } from "./components/Calculator";
import { LongDistance } from "./components/LongDistance";
import { PopularRoutes } from "./components/PopularRoutes";
import { Fleet } from "./components/Fleet";
import { BookingForm } from "./components/BookingForm";
import { Footer } from "./components/Footer";
import { SeoManager } from "./components/SeoManager";
import { Button } from "./components/ui/button";
import { getConfig } from "./lib/api";

function MobileBookBar() {
  const { t } = useI18n();
  const { requestBooking } = useBooking();
  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-background/95 backdrop-blur border-t border-border px-4 py-3">
      <Button className="w-full rounded-xl active:scale-[0.98]" size="lg" onClick={() => requestBooking({})} data-testid="mobile-book-bar-button">
        {t("cta.book")}
      </Button>
    </div>
  );
}

function Site() {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    getConfig().then(setConfig).catch(() => setConfig(null));
  }, []);

  return (
    <div className="App min-h-screen bg-background pb-16 lg:pb-0">
      <SeoManager />
      <Header />
      <main>
        <Hero />
        <Benefits />
        <Services />
        <Calculator config={config} />
        <LongDistance />
        <PopularRoutes />
        <Fleet config={config} />
        <BookingForm config={config} />
      </main>
      <Footer />
      <MobileBookBar />
      <Toaster position="top-center" richColors />
    </div>
  );
}

function App() {
  return (
    <I18nProvider>
      <CurrencyProvider>
        <BookingProvider>
          <Site />
        </BookingProvider>
      </CurrencyProvider>
    </I18nProvider>
  );
}

export default App;
